import { z } from "zod";

// Format 1: Record/Object e.g., {"Bali": 5, "Jakarta": 12}
const RecordSchema = z.record(z.string(), z.number());

// Format 2: Array of objects e.g., [{"region_name": "Bali", "total_properties": 5}]
const ObjectSchema = z.object({
    region_name: z.string(),
    total_properties: z.number(),
});
const ArraySchema = z.array(ObjectSchema).transform((arr) => {
    const record: Record<string, number> = {};
    arr.forEach((item) => {
        record[item.region_name] = item.total_properties;
    });
    return record;
});

// Format 3: Array of objects with alternative keys if it might be e.g., [{"name": "Bali", "total": 5}]
const AltObjectSchema = z.object({
    name: z.string(),
    total: z.number(),
});
const AltArraySchema = z.array(AltObjectSchema).transform((arr) => {
    const record: Record<string, number> = {};
    arr.forEach((item) => {
        record[item.name] = item.total;
    });
    return record;
});

// Format 4: Real API response format e.g., [{"region": "test", "total": 2}]
const RealApiObjectSchema = z.object({
    region: z.string(),
    total: z.number(),
});
const RealApiArraySchema = z.array(RealApiObjectSchema).transform((arr) => {
    const record: Record<string, number> = {};
    arr.forEach((item) => {
        record[item.region] = item.total;
    });
    return record;
});

const NormalizedDataSchema = z.union([RecordSchema, ArraySchema, AltArraySchema, RealApiArraySchema]);

export const PropertyRegionStatisticsResponse = z.object({
    success: z.boolean().optional().default(true),
    message: z.string().optional().nullable(),
    code: z.number().optional().nullable(),
    data: NormalizedDataSchema,
});

export type PropertyRegionStatisticsResponseType = z.infer<typeof PropertyRegionStatisticsResponse>;
